const AccidentClaimTypeValues = {
    FIRE: 'FIRE',
    VANDALISM: 'VANDALISM',
    THEFT: 'THEFT',
    GLASS: 'GLASS',
    AT_FAULT_ACCIDENT: 'AT_FAULT_ACCIDENT',
    NOT_AT_FAULT_ACCIDENT: 'NOT_AT_FAULT_ACCIDENT',
    INJURY_RECOVERY_EXPENSES: 'INJURY_RECOVERY_EXPENSES',
    STOLEN_VEHICLE: 'STOLEN_VEHICLE',
};

export default AccidentClaimTypeValues;
